import React from 'react';
import { Route } from 'react-router-dom';
import _ from 'lodash';
import dollarsToCents from 'dollars-to-cents';
import SectionGroup from 'app/components/general/SectionGroup';

import PaymentCard from 'app/components/matches/PaymentCard';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  unformatAmount, formatAmount, unformatAmountDollarSign, parseAmount, parseFloatCurrency, utf8ToB64, b64ToUtf8,
} from 'app/utils/parsers';
import history from 'app/routes/history';
import HeaderThin from 'app/components/layout/HeaderThin';
import ProgressIndicator, { IStep } from 'app/components/general/ProgressIndicator';
import { ITeamMemberRow } from 'app/components/teamMembers/TeamMembersTableSelectable';
import splitTypes from 'app/utils/static/splitTypes';
import collectCategories from 'app/utils/static/collectCategories';

import * as teamPaymentRequestActions from 'app/ducks/teamPaymentRequests/actions';
import * as teamMemberActions from 'app/ducks/teamMembers/actions';
import * as teamActions from 'app/ducks/teams/actions';
import * as groupActions from 'app/ducks/groups/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as teamPaymentRequestsSelectors from 'app/ducks/teamPaymentRequests/selectors';
import * as organisationsSelectors from 'app/ducks/organisations/selectors';
import * as teamMembersSelectors from 'app/ducks/teamMembers/selectors';
import * as teamsSelectors from 'app/ducks/teams/selectors';
import * as usersSelectors from 'app/ducks/users/selectors';
import * as paymentEventsActions from 'app/ducks/paymentEvents/actions';

import * as paymentEventsSelectors from 'app/ducks/paymentEvents/selectors';

import Loader from 'app/components/general/Loader';
import Step1PaymentDetail from './Step1PaymentDetail';
import Step2SelectTeamMembers from './Step2SelectTeamMembers';
import Step4Confirm from './Step4Confirm';

interface INewPaymentRequestProps {
  backendErrors?: any;
  actions?: any;
  match?: any;
  organisations?: any;
  organisationTags?: any;
  teamMembers?: any;
  teamPaymentRequests?: any;
  teams?: any;
  users?: any;
  appReady?: boolean;
}

interface INewPaymentRequestState {
  // initialFilter: any;
  error?: string;
  payeeType: string;
  selectedTeamMembersIds: string[];
  selectedTeamMembersById: any;
  selectedAllRows: boolean;
  teamMembersLoaded: boolean;
  // selectedRowIds: string[];
  // selectedRows: any;
  // errors: any;
  // changed: boolean;
  // saved: boolean;
  originalFormData: {
    paymentType: string;
    description: string;
    amount: string;
    dueDate: string;
  };
  formData: {
    paymentType: any;
    description: string;
    amount: string;
    dueDate: string;
    matchPaymentId: string;
    forfeitId: string;
    groupId: string;
    splitType: any;
  };
  groupId: string;
  paymentEventId: string;
  changed: boolean;
  saved: boolean;
  errors: any;
  teamMemberRows?: { [key: string]: ITeamMemberRow };
}

const defaultRows = (teamMemberIds, user = undefined, teamMembersById, splitType): any => {
  const rows = {
    teamManager: {
      id: 'teamManager',
      fullName: `${user?.firstName} ${user?.lastName}`,
      teamName: 'Team Manager',
      selected: false,
      amount: undefined,
      className: 'highlighted',
      quantity: 1,
      customAmount: false,
      splitType,
    },
  };

  _.map(teamMemberIds, (id) => {
    const teamMember = teamMembersById[id];
    rows[id] = {
      id,
      selected: false,
      amount: undefined,
      quantity: 1,
      customAmount: false,
      fullName: teamMember?.fullName,
      teamName: teamMember?.teamName,
      splitType,
    };
  });
  return rows;
};

function selector(state): any {
  return {
    // teamPaymentRequests: state.teamPaymentRequests,
    teamPaymentRequests: teamPaymentRequestsSelectors.getTeamPaymentRequests(state),
    organisations: organisationsSelectors.getOrganisations(state),
    teamMembers: teamMembersSelectors.getTeamMembers(state),
    paymentEvents: paymentEventsSelectors.getPaymentEvents(state),
    teams: teamsSelectors.getTeams(state),
    users: usersSelectors.getUsers(state),
    appReady: loadingSelectors.appReady(state),
  };
}

const actionCreators = _.merge(
  teamPaymentRequestActions,
  teamMemberActions,
  teamActions,
  paymentEventsActions,
  groupActions,
);

@connect(
  selector,
  (dispatch) => ({
    actions: bindActionCreators(actionCreators, dispatch),
  }),
)
export default class NewPaymentRequest extends React.Component<INewPaymentRequestProps, INewPaymentRequestState> {
  static decodePreconfigData = (nextProps): any => {
    const preconfigData = nextProps.match?.params?.preconfigData ? JSON.parse(b64ToUtf8(nextProps.match?.params?.preconfigData)) : {};
    return preconfigData;
  }

  static compilePreconfigData = (nextProps): any => {
    const preconfigData = NewPaymentRequest.decodePreconfigData(nextProps);

    const compiledPreconfigData = {
      paymentType: preconfigData?.category || collectCategories[0],
      description: preconfigData?.description,
      amount: preconfigData?.amount,
      dueDate: [preconfigData?.dueDate],
      splitType: preconfigData.splitType || splitTypes[1],
      forfeitId: preconfigData?.forfeitId,
      matchPaymentId: preconfigData?.matchPaymentId,
      groupId: preconfigData?.groupId,
    };
    return compiledPreconfigData;
  }

  static compileParsedConfigData = (nextProps, newState): any => {
    const preconfigData = NewPaymentRequest.decodePreconfigData(nextProps);

    const compiledPreconfigData = {
      paymentType: newState.category,
      description: newState.description,
      amount: newState.amount,
      dueDate: newState.dueDate[0],
      splitType: newState.splitType,
      forfeitId: newState.forfeitId,
      matchPaymentId: newState.matchPaymentId,
      groupId: newState.groupId,
    };
    return compiledPreconfigData;
  }

  static defaultProps: INewPaymentRequestProps = {
    match: undefined,
    backendErrors: undefined,
    actions: undefined,
    organisations: undefined,
    organisationTags: undefined,
    teamMembers: undefined,
    teams: undefined,
    users: undefined,
    appReady: false,
  };

  state: INewPaymentRequestState = {
    formData: {
      paymentType: collectCategories[0],
      description: undefined,
      amount: undefined,
      dueDate: undefined,
      splitType: splitTypes[0],
    },
    originalFormData: {
      paymentType: undefined,
      description: undefined,
      amount: undefined,
      dueDate: undefined,
    },
    payeeType: 'individuals',
    selectedRows: {},
    selectedAllRows: false,
    selectedRowIds: [],
    errors: {},
    groupId: undefined,
    paymentEventId: undefined,
    changed: false,
    saved: false,
    defaultRowsSet: false,
    initialFilter: undefined,
  };

  componentDidMount(): void {
    const decodedPreconfigData = NewPaymentRequest.decodePreconfigData(this.props);
    // console.log(decodedPreconfigData.paymentEventId);
    // console.log(decodedPreconfigData.groupId);
    // console.log(decodedPreconfigData.matchPaymentId);
    this.props.actions.clearPaymentRequest();
    if (
      this.props.appReady
    ) {
      this.props.actions.getAllTeamMembers({
        page: {
          size: 1000,
        },
      }, false);
      this.props.actions.getAllTeams({}, false);
    }
    if (decodedPreconfigData.paymentEventId !== undefined) {
      this.props.actions.getPaymentEvent(
        decodedPreconfigData.paymentEventId,
      );
      this.props.actions.selectPaymentEvent(
        decodedPreconfigData.paymentEventId,
      );
    }
    if (decodedPreconfigData.groupId !== undefined) {
      this.props.actions.getGroup(decodedPreconfigData.groupId);
      this.setState({ groupId: decodedPreconfigData.groupId, paymentEventId: decodedPreconfigData.paymentEventId });
    }
  }

  static getDerivedStateFromProps(nextProps, prevState): any {
    // const teamMembersLoaded = prevState.teamMemberRows !== undefined
    //   && nextProps.teamMembers.isLoading === false
    //   && (nextProps.teamMembers.teamMemberIds?.length === (Object.keys(prevState.teamMemberRows).length - 1));
    const teamMembersLoaded = prevState.teamMemberRows !== undefined
      && nextProps.teamMembers.isLoading === false
      && prevState.defaultRowsSet;

    if (!prevState.changed && nextProps.teamMembers.isLoading === false) {
      const compiledPreconfigData = NewPaymentRequest.compilePreconfigData(nextProps);
      const formData = nextProps.teamPaymentRequests?.formData?.description !== undefined ? nextProps.teamPaymentRequests?.formData : compiledPreconfigData;
      return {
        ...prevState,
        errors: nextProps.errors,
        formData,
        teamMembersLoaded,
        defaultRowsSet: true,
        teamMemberRows: defaultRows(nextProps.teamMembers.teamMemberIds,
          nextProps.users?.currentUser,
          nextProps.teamMembers.teamMembersById,
          prevState.formData?.splitType?.id),
      };
    }
    return null;
  }

  isValid = (): boolean => _.isEmpty(this.state.errors);

  handleChange = (e): void => {
    const changed = this.state.originalFormData !== e.formData;
    this.setState((previousState) => ({
      formData: e.formData,
      teamMemberRows: this.calculateRows(previousState,
        e.formData.splitType?.id,
        unformatAmountDollarSign(e.formData?.amount),
        this.selectedTeamMemberIds(previousState.teamMemberRows)),
      errors: [],
      changed,
    }));

    // , () => {
    //   const base64ConfigData = base64.encode(JSON.stringify(this.compiledParsedConfigData()));
    //   history.push(`/payment-requests/new:${base64ConfigData}`);
    // }
  };

  handleError = (errors): void => {
    this.setState({ errors });
  }

  handleChangePayeeType = (e): void => {
    this.setState(() => ({
      payeeType: e,
    }));
  };

  allRowsSelected = (teamMemberRows, selectedRows): boolean => Object.keys(teamMemberRows)?.length === selectedRows.length

  updateSelectedRows = (prevState, selectedRows): any => {
    // console.log(prevState);
    // console.log(selectedRows);
    const selectedRowIds = _.keys(_.pickBy(selectedRows, (d) => d));

    return {
      ...prevState,
      selectedRowIds,
      selectedRows,
    };
  }

  selectRow = (ids: string[]): void => {
    this.setState((previousState) => {
      const newState = previousState;
      const selected = previousState.teamMemberRows[ids[0]]?.selected === undefined ? true : !previousState.teamMemberRows[ids[0]]?.selected;
      _.map(ids, (id) => {
        newState.teamMemberRows[id] = {
          ...previousState.teamMemberRows[id],
          selected,
        };
      });
      const selectedAllRows = this.allRowsSelected(newState.teamMemberRows, this.selectedTeamMemberIds(newState.teamMemberRows));
      return {
        changed: true,
        changedSelectedRow: true,
        teamMemberRows: this.calculateRows(previousState, newState.formData.splitType?.id, unformatAmountDollarSign(newState.formData?.amount), this.selectedTeamMemberIds(newState.teamMemberRows)),
        selectedAllRows,
      };
    });
  };

  handleSelectAllRows = (): void => {
    this.setState((previousState) => {
      const selectionValue = !previousState.selectedAllRows;
      const selectedRows = this.selectAllRows(previousState.teamMemberRows, selectionValue);
      const newState = {
        ...previousState,
        teamMemberRows: selectedRows,
      };
      // console.log(selectionValue);
      // console.log(selectedRows);
      // const teamMemberRows = this.calculateRows(previousState, previousState.formData.splitType?.id, unformatAmountDollarSign(previousState.formData?.amount), this.selectedTeamMemberIds(selectedRows));
      return {
        changed: true,
        changedSelectedRow: false,
        selectedAllRows: selectionValue,
        teamMemberRows: this.calculateRows(newState, newState.formData.splitType?.id, unformatAmountDollarSign(newState.formData?.amount), this.selectedTeamMemberIds(newState.teamMemberRows)),
      };
    });
  }

  selectAllRows = (teamMemberRows, selectionValue = !this.state.selectedAllRows): any => {
    const selectedRows = {};
    // amount: value.amount,
    _.map(teamMemberRows, (value, key) => {
      selectedRows[key] = {
        ...teamMemberRows[key],
        selected: selectionValue,
      };
    });

    return selectedRows;
  };

  removeRow = (id): void => {
    this.setState((prevState) => {
      const selectedRows = {
        ...prevState.selectedRows,
        [id]: false,
      };

      return this.updateSelectedRows(prevState, selectedRows);
    });
  };

  removeAllRows = (rows): void => {
    this.setState((prevState) => {
      const selectedRows = {};

      _.map(rows, (row) => {
        selectedRows[row.id] = false;
      });

      return this.updateSelectedRows(prevState, selectedRows);
    });
  };

  handleRowAmountChange = (id, values): void => {
    const { formattedValue, value } = values;
    this.setState((previousState) => {
      const customAmount = previousState.formData.splitType?.id !== 'total' && !_.isEmpty(formattedValue) && formatAmount(previousState.formData.amount) !== formattedValue;
      const newPayload = {
        changed: true,
        teamMemberRows: {
          ...previousState.teamMemberRows,
          [id]: {
            ...previousState.teamMemberRows[id],
            id,
            amount: value,
            customAmount,
            floatAmount: parseFloatCurrency(value),
          },
        },
      };
      return newPayload;
    });
  };

  handleRowQuantityChange = (id, value): void => {
    this.setState((previousState) => {
      const newPayload = {
        changed: true,
        teamMemberRows: {
          ...previousState.teamMemberRows,
          [id]: {
            ...previousState.teamMemberRows[id],
            id,
            quantity: parseInt(value),
          },
        },
      };
      const newState = {
        ...previousState,
        ...newPayload,
      };
      newPayload.teamMemberRows = this.calculateRows(newState,
        newState.formData?.splitType?.id,
        unformatAmountDollarSign(newState.formData?.amount),
        this.selectedTeamMemberIds(newState.teamMemberRows));

      // console.log(newPayload);
      return newPayload;
    });
  };

  perPersonRows = (previousState, amount, selectedTeamMemberIds): any => {
    const rows = {};
    const combinedIds = _.concat(this.props.teamMembers.teamMemberIds, _.map(previousState.teamMemberRows, (r) => r.id));
    _.map(combinedIds, (id) => {
      const selected = _.includes(selectedTeamMemberIds, id);
      const tmAmount = previousState.teamMemberRows[id]?.floatAmount;
      const parsedAmount = previousState.teamMemberRows[id]?.customAmount ? tmAmount * 100 : amount * 100;

      const finalParsedAmount = selected ? parseAmount(parsedAmount) : '';
      const floatAmount = selected ? parsedAmount / 100 : 0;

      // if (selected) {
      //   console.log(id);
      //   console.log(parseAmount(tmAmount));
      //   console.log(tmAmount);
      //   console.log(parsedAmount);
      //   console.log(previousState.teamMemberRows[id]);
      // }
      rows[id] = {
        ...previousState.teamMemberRows[id], amount: finalParsedAmount, floatAmount, selected,
      };
    });
    return rows;
  }

  totalRows = (previousState, amount, selectedTeamMemberIds): any => {
    const rows = {};
    const combinedIds = _.concat(this.props.teamMembers.teamMemberIds, _.map(previousState.teamMemberRows, (r) => r.id));
    // console.log('gggggg');
    // console.log(previousState);
    // console.log(amount);
    // console.log(parseFloatCurrency(amount));
    // console.log(selectedTeamMemberIds);
    // console.log('hhhhhh');
    const numberOfTeamMembers = this.quantityOfTeamMembers(previousState.teamMemberRows);
    const splitAmount = (parseFloatCurrency(amount) / numberOfTeamMembers) * 100;
    // console.log(numberOfTeamMembers);
    // console.log(parseAmount(splitAmount));
    _.map(combinedIds, (id) => {
      // const tmAmount = previousState.teamMemberRows[id]?.amount;
      const tmQuantity = previousState.teamMemberRows[id]?.quantity;
      const tmTotalAmount = splitAmount * tmQuantity;
      // console.log(tmQuantity);
      // console.log(tmTotalAmount);
      const selected = _.includes(selectedTeamMemberIds, id);
      const parsedAmount = selected ? parseAmount(tmTotalAmount) : '';
      const floatAmount = selected ? tmTotalAmount / 100 : 0;
      rows[id] = {
        ...previousState.teamMemberRows[id], floatAmount, amount: parsedAmount, selected,
      };
    });

    // console.log('rows');
    // console.log(rows);
    return rows;
  }

  calculateRows = (previousState, splitType, amount, selectedTeamMemberIds): any => {
    let rows = {};

    // console.log('calculate rows');
    // console.log(previousState);
    // console.log(splitType);
    // console.log(amount);
    // console.log(selectedTeamMemberIds);
    switch (splitType) {
      case 'per-person':
        rows = this.perPersonRows(previousState, unformatAmountDollarSign(amount), selectedTeamMemberIds);
        break;
      case 'total':
        rows = this.totalRows(previousState, unformatAmountDollarSign(amount), selectedTeamMemberIds);
        break;
      default:
        return {};
    }
    const filteredRows = _.pickBy(rows, (value, key) => !_.isEmpty(key));
    // console.log(filteredRows);
    return filteredRows;
  }

  selectedTeamMemberIds = (teamMemberRows): string[] => _.compact(_.map(teamMemberRows, (row, key) => {
    if (row.selected) {
      return key;
    }
  }))

  selectedTeamMembers = (teamMemberRows: ITeamMemberRow[]): ITeamMemberRow[] => _.compact(_.map(teamMemberRows, (row) => {
    if (row.selected) {
      return row;
    }
  }))

  numberOfSelectedTeamMembers = (teamMemberRows = this.state.teamMemberRows): number => this.selectedTeamMemberIds(teamMemberRows).length

  quantityOfTeamMembers = (teamMemberRows = this.state.teamMemberRows): number => _.sum(_.map(this.selectedTeamMembers(teamMemberRows), (r) => r.quantity))

  amountDescription = (): string => {
    switch (this.state.formData?.splitType?.id) {
      case 'per-person':
        return '($ per person)';
      case 'total':
        return '($ split between)';
      default:
        return '';
    }
  }

  amountCalculated = (): number => {
    let amount = unformatAmountDollarSign(this.state.formData.amount) * 100;
    switch (this.state.formData?.splitType?.id) {
      case 'total':
        amount = (unformatAmountDollarSign(this.state.formData.amount) / this.numberOfSelectedTeamMembers()) * 100;
        break;
      default:
        break;
    }
    return amount;
  }

  amountTotalCustom = (): number => {
    // console.log('custom');
    // console.log(this.state.teamMemberRows);

    if (_.find(this.state.teamMemberRows, (r) => r.customAmount) !== undefined) {
      const customSelected = _.map(this.state.teamMemberRows, (r) => {
        // console.log(r);

        if (r.selected) {
          return parseFloatCurrency(r.amount);
        }
        return 0;
      });
      const calculatedAmount = _.sum(customSelected);
      // console.log('custom');
      // console.log(calculatedAmount);

      return calculatedAmount;
    }
    return -1;
  }

  amountTotal = (): { amount: number; amountDeducted: number; amountTotal: number } => {
    let amount = unformatAmountDollarSign(this.state.formData.amount) * 100;
    let customAmount = this.amountTotalCustom();
    let amountDeducted = 0;
    let amountTotal = 0;
    // console.log(customAmount);

    // console.log('amount total');
    // console.log(this.state.formData.amount);
    // console.log(amount);
    // console.log(customAmount);
    // console.log(this.numberOfSelectedTeamMembers());

    if (customAmount !== -1) {
      customAmount *= 100;
      amountTotal = customAmount;
      if (this.state.teamMemberRows?.teamManager?.selected === true) {
        amountDeducted = this.state.teamMemberRows?.teamManager?.floatAmount * 100;
        customAmount -= amountDeducted;
      }
      return { amount: customAmount, amountDeducted, amountTotal };
    }
    // console.log('per pers');
    // console.log(amount);
    // console.log(customAmount);
    switch (this.state.formData?.splitType?.id) {
      case 'per-person':
        // console.log(unformatAmountDollarSign(this.state.formData.amount));
        // console.log(this.numberOfSelectedTeamMembers());
        amount = (unformatAmountDollarSign(this.state.formData.amount) * this.numberOfSelectedTeamMembers()) * 100;
        break;
      default:
        break;
    }

    amountTotal = amount;
    if (this.state.teamMemberRows?.teamManager?.selected === true) {
      amountDeducted = (this.state.teamMemberRows?.teamManager?.floatAmount * 100);
      amount -= amountDeducted;
    }
    return { amount, amountDeducted, amountTotal };
  }

  handleDetailNext = (e): void => {
    this.props.actions.updatePaymentRequest({
      formData: e.formData,
      errors: [],
    });
    const base64ConfigData = utf8ToB64(JSON.stringify(this.compiledParsedConfigData()));
    history.push(`/payment-requests/new:${base64ConfigData}`);
    history.push(`/payment-requests/new/select:${base64ConfigData}`);

    // this.setState({ changed: false });
  }

  handleSubmit = (e): void => {
    e.preventDefault();
    if (
      this.isValid()
      && !this.props.teamPaymentRequests.isLoading
      && this.props.teamMembers.hasLoaded
    ) {
      const filteredRows = _.filter(this.selectedTeamMembers(this.state.teamMemberRows), (r) => r.id !== 'teamManager');
      const teamMembers = _.map(filteredRows, (o) => ({
        'team-member-id': o.id,
        amount: dollarsToCents((o.floatAmount) || (this.amountCalculated() / 100)),
      }));
      const teamManagerAmount = this.state.teamMemberRows?.teamManager?.selected ? this.state.teamMemberRows?.teamManager?.floatAmount : 0;
      // const consumerIds = _.map(this.selectedTeamMemberIds(this.state.teamMemberRows), (o) => ({
      //   id: this.props.teamMembers.teamMembersById[o].consumer.id,
      // }));
      const payload = {
        description: this.state.formData.description,
        amount: dollarsToCents(this.amountCalculated() / 100),
        paymentCategory: 'team-collection',
        paymentType: 'team-manager',
        metadataCategory: this.state.formData.paymentType?.id,
        deductedAmount: dollarsToCents(teamManagerAmount),
        dueAt: this.state.formData.dueDate[0],
        paymentRequestsTeamMembersAttributes: teamMembers,
        matchPayment: {
          id: this.state.formData.matchPaymentId,
        },
        forfeit: {
          id: this.state.formData.forfeitId,
        },
        group: {
          id: this.state.formData.groupId,
        },
      };
      // console.log(payload);
      this.props.actions.createTeamPaymentRequest(payload);
    }
  };

  compiledPreconfigData = (): any => NewPaymentRequest.compilePreconfigData(this.props)

  compiledParsedConfigData = (): any => NewPaymentRequest.compileParsedConfigData(this.props, this.state.formData)

  render(): React.ReactNode {
    // const decodedPreconfigData = NewPaymentRequest.decodePreconfigData(this.props);
    // console.log(decodedPreconfigData);
    // console.log(NewPaymentRequest.compileParsedConfigData(this.props, this.state.formData));
    // console.log(this.amountTotal());
    const steps: IStep[] = [
      {
        number: 1,
        text: 'Payment Details',
        complete: this.props.match.url !== '/payment-requests/new',
        active: this.props.match.url === '/payment-requests/new',
      },
      {
        number: 2,
        text: 'Select Team Member/s',
        complete: _.includes(['/payment-requests/new/confirm', '/payment-requests/new/notifications'], this.props.match.url),
        active: this.props.match.url === '/payment-requests/new/select',
      },
      {
        number: 3,
        text: 'Confirm',
        complete: false,
        active: this.props.match.url === '/payment-requests/new/confirm',
      },
    ];
    const { currentPaymentEvent } = this.props.paymentEvents;

    return (
      <div>
        <div className="row">
          <div className="col">
            <HeaderThin
              title="New Payment Request"
              breadcrumb="Payment Requests"
              breadcrumbLink="/payment-requests"
            />
          </div>
        </div>

        <Route
          exact
          path={['/payment-requests/new', '/payment-requests/new\\::preconfigData']}
          render={() => (
            <div>
              <div className="row">
                <div className="col col-12 col-lg-10 col-xl-8">
                  <Step1PaymentDetail
                    match={this.props.match}
                    isValid={this.isValid}
                    handleChange={this.handleChange}
                    handleError={this.handleError}
                    handleSubmit={this.handleDetailNext}
                    currentPaymentEvent={currentPaymentEvent}
                    groupId={this.state.groupId}
                    formData={this.state.formData}
                    errors={this.props.teamPaymentRequests.backendErrors}
                    changed={this.state.changed}
                    teamMembersLoaded={this.state.teamMembersLoaded}
                    amountDescription={this.amountDescription()}
                    teamPaymentRequests={this.props.teamPaymentRequests}
                    originalFormData={this.state.originalFormData}
                    users={this.props.users}
                  >
                    <ProgressIndicator steps={steps} />
                  </Step1PaymentDetail>
                </div>
              </div>
            </div>
          )}
        />
        <Route
          exact
          path={['/payment-requests/new/select', '/payment-requests/new/select\\::preconfigData']}
          render={() => (
            <div className="row">
              <div className="col col-12">
                <Step2SelectTeamMembers
                  match={this.props.match}
                  updateSelectedRows={this.updateSelectedRows}
                  handleChangePayeeType={this.handleChangePayeeType}
                  actions={this.props.actions}
                  appReady={this.props.appReady}
                  teamMembers={this.props.teamMembers}
                  teams={this.props.teams}
                  totalAmount={this.amountTotal()}
                  selectRow={this.selectRow}
                  selectedAllRows={this.state.selectedAllRows}
                  selectAllRows={this.handleSelectAllRows}
                  removeRow={this.removeRow}
                  removeAllRows={this.removeAllRows}
                  rows={this.state.teamMemberRows}
                  handleAmountChange={this.handleRowAmountChange}
                  handleQuantityChange={this.handleRowQuantityChange}
                  defaultAmount={this.state.formData.amount}
                  splitType={this.state.formData?.splitType?.id}
                >
                  <ProgressIndicator steps={steps} />
                </Step2SelectTeamMembers>
              </div>
            </div>
          )}
        />
        <Route
          exact
          path={['/payment-requests/new/confirm', '/payment-requests/new/confirm\\::preconfigData']}
          render={() => (
            <div className="row with-margin-top-20">
              <div className="col col-12 col-lg-10 col-xl-8">
                <Step4Confirm
                  match={this.props.match}
                  actions={this.props.actions}
                  appReady={this.props.appReady}
                  isValid={this.isValid}
                  handleChange={this.handleChange}
                  handleSubmit={this.handleSubmit}
                  currentPaymentEvent={currentPaymentEvent}
                  groupId={this.state.groupId}
                  teamMembers={this.props.teamMembers}
                  formData={this.state.formData}
                  payeeType={this.state.payeeType}
                  errors={this.props.teamPaymentRequests.backendErrors}
                  selectedRowIds={this.state.selectedRowIds}
                  selectedRows={this.state.selectedRows}
                  rows={this.state.teamMemberRows}
                  changed={this.state.changed}
                  splitType={this.state.formData?.splitType?.id}
                  teamPaymentRequests={this.props.teamPaymentRequests}
                  totalAmount={this.amountTotal()}
                  originalFormData={this.state.originalFormData}
                >
                  <ProgressIndicator steps={steps} />
                </Step4Confirm>
              </div>
            </div>

          )}
        />
      </div>
    );
  }
}
